export interface ICaseNewMessage {
  message: string;
  sendEmailCopy: boolean;
}

export const emptyNewCaseMessage: ICaseNewMessage = {
  message: '',
  sendEmailCopy: false,
};
